import Splide from '@splidejs/splide';

export const updateNextArrowState = (splide?: Splide) => {
  if (!splide.state.is(Splide.STATES.IDLE)) return;
  // disable when on last slide, or if everything is visible
  if (
    (splide && splide.index === splide.length - 1) ||
    isLastSlideVisible(splide)
  ) {
    splide.Components.Arrows.arrows.next.classList.add('disabled');
  } else {
    splide.Components.Arrows.arrows.next.classList.remove('disabled');
  }
};

export const isLastSlideVisible = (splide: Splide) => {
  return splide.Components.Slides.getAt(
    splide.length - 1,
  ).slide.classList.contains('is-visible');
};
